import { raise, StateSchema, StatesConfig } from 'xstate'

import {
  QuizEvents,
  QuizMachineContext
} from '@f/applications/QuizApp/stateMachine/initializeQuizMachine'

import {
  MID_STEP_LOADER_APPEARANCE_TIME,
  STEP_TRANSITION_DURATION,
  STEP_TRANSITION_IN_OUT_DURATION
} from '../partials/quizConstants'

const TRANSITION_TIME =
  STEP_TRANSITION_DURATION + STEP_TRANSITION_IN_OUT_DURATION

const NEXT_STEP_ACTIONS = [
  'moveToNextStep',
  'updateVisitedSteps',
  'trackQuestionDisplay'
]

const PREV_STEP_ACTIONS = [
  'moveToPrevStep',
  'trackQuestionDisplay',
  raise({ type: 'DISPLAY_STEP' }, { delay: TRANSITION_TIME })
]

export const states: StatesConfig<
  QuizMachineContext,
  StateSchema<QuizMachineContext>,
  QuizEvents
> = {
  'pre-checkout': {
    entry: ['trackQuestionDisplay'],
    on: {
      NEXT_STEP: [
        {
          target: 'checkout',
          actions: NEXT_STEP_ACTIONS,
          cond: 'isLastStepBeforeCheckout'
        },
        {
          actions: NEXT_STEP_ACTIONS
        }
      ],
      SUBMIT: [
        {
          actions: [raise({ type: 'NEXT_STEP' })],
          cond: 'isLastStepBeforeCheckout'
        },
        {
          actions: [
            'startLoaderTransition',
            raise(
              { type: 'FINISH_TRANSITION' },
              { delay: MID_STEP_LOADER_APPEARANCE_TIME }
            ),
            raise(
              { type: 'NEXT_STEP' },
              { delay: MID_STEP_LOADER_APPEARANCE_TIME + TRANSITION_TIME }
            )
          ],
          cond: 'isStepWithTransition'
        },
        {
          actions: [
            'startLoaderTransition',
            raise({ type: 'FINISH_TRANSITION' }),
            raise({ type: 'NEXT_STEP' }, { delay: TRANSITION_TIME })
          ]
        }
      ],
      DISPLAY_STEP: {
        actions: ['showStep']
      },
      FINISH_TRANSITION: {
        actions: ['endLoaderTransition', 'hideStep']
      },
      PREV_STEP: {
        actions: PREV_STEP_ACTIONS,
        cond: 'isNotFirstStep'
      }
    }
  },
  checkout: {
    on: {
      NEXT_STEP: [
        {
          target: 'success',
          actions: NEXT_STEP_ACTIONS,
          cond: 'canMoveToSuccess'
        },
        {
          target: 'validation',
          actions: ['moveToNextStep', 'updateVisitedSteps'],
          cond: 'canMoveToValidation'
        },
        { actions: NEXT_STEP_ACTIONS }
      ],
      SUBMIT: {
        actions: [
          'hideStep',
          raise({ type: 'NEXT_STEP' }, { delay: TRANSITION_TIME })
        ]
      },
      PREV_STEP: [
        {
          target: 'pre-checkout',
          actions: PREV_STEP_ACTIONS,
          cond: 'isFirstCheckoutStep'
        },
        { actions: ['moveToPrevStep', 'showStep'] }
      ]
    }
  },
  validation: {
    on: {
      NEXT_STEP: [
        {
          target: 'success',
          actions: NEXT_STEP_ACTIONS,
          cond: 'canMoveToSuccess'
        }
      ]
    }
  },
  success: {}
}
